import VuexStore from '../store';

const Helper = {
    install (Vue) {
        Vue.mixin({
            mounted() {

            }
        });

        Vue.prototype.$getExpressions = function() {
            return VuexStore.state.expressions;
        };

        Vue.prototype.$getExpressions1 = function() {
            return VuexStore.state.expressions1;
        };
        
    }
}

export default Helper;